var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen.lock",
          value: _vm.fullscreenLoading,
          expression: "fullscreenLoading",
          modifiers: { fullscreen: true, lock: true },
        },
      ],
      attrs: {
        title: "修改密码",
        "close-on-click-modal": false,
        visible: _vm.innerVisible,
        width: "400px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.innerVisible = $event
        },
      },
    },
    [
      _c(
        "zj-form",
        {
          ref: "companyForm",
          attrs: {
            model: _vm.companyForm,
            rules: _vm.companyRules,
            "label-width": "100px",
            size: "small",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "组织类型", prop: "orgnization" } },
            [
              _c(
                "el-radio",
                {
                  attrs: { label: "school" },
                  on: {
                    change: function ($event) {
                      return _vm.refreshCompanyData()
                    },
                  },
                  model: {
                    value: _vm.companyForm.orgnization,
                    callback: function ($$v) {
                      _vm.$set(_vm.companyForm, "orgnization", $$v)
                    },
                    expression: "companyForm.orgnization",
                  },
                },
                [_vm._v("学校")]
              ),
              _vm._v(" "),
              _c(
                "el-radio",
                {
                  attrs: { label: "company" },
                  on: {
                    change: function ($event) {
                      return _vm.refreshCompanyData()
                    },
                  },
                  model: {
                    value: _vm.companyForm.orgnization,
                    callback: function ($$v) {
                      _vm.$set(_vm.companyForm, "orgnization", $$v)
                    },
                    expression: "companyForm.orgnization",
                  },
                },
                [_vm._v("企业")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.showCompany
            ? _c(
                "el-form-item",
                { attrs: { prop: "c_name", label: "组织名称" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "250px" },
                      attrs: {
                        placeholder: "请选择或输入学校、组织",
                        filterable: "",
                        "filter-method": _vm.loadCompany,
                      },
                      model: {
                        value: _vm.companyForm.c_name,
                        callback: function ($$v) {
                          _vm.$set(_vm.companyForm, "c_name", $$v)
                        },
                        expression: "companyForm.c_name",
                      },
                    },
                    _vm._l(_vm.companyDataShow, function (item) {
                      return _c("el-option", {
                        key: item.code,
                        attrs: { label: item.name, value: item.name },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "zj-form-bottom" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.innerVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.onChangeClick },
                },
                [_vm._v("确认修改")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }